type ApiErrorInit = {
  error: string;
  message: string;
  details: Record<string, unknown>;
  requestId: string | undefined;
  status: number;
};

export class ApiError extends Error {
  public readonly error: string;
  public readonly details: Record<string, unknown>;
  public readonly requestId: string | undefined;
  public readonly status: number;

  constructor(init: ApiErrorInit) {
    super(init.message);
    this.name = "ApiError";
    this.error = init.error;
    this.details = init.details;
    this.requestId = init.requestId;
    this.status = init.status;
  }
}

export class LegalReacceptDeclined extends Error {
  public readonly flavor: "terms" | "privacy";
  constructor(flavor: "terms" | "privacy") {
    super("Legal reaccept declined");
    this.name = "LegalReacceptDeclined";
    this.flavor = flavor;
  }
}
